const MOBILE_DIGITS = /^[6-9][0-9]{9}$/;
const COUNTRY_CODE = "91";
export const MOBILE_LENGTH = 10;

// Keeps only digits, drops a leading +91 country code and caps the length.
export function sanitizeMobile(value) {
  let digits = String(value ?? "").replace(/\D/g, "");
  if (digits.length > MOBILE_LENGTH && digits.startsWith(COUNTRY_CODE)) {
    digits = digits.slice(COUNTRY_CODE.length);
  }
  return digits.slice(0, MOBILE_LENGTH);
}

export function isValidMobile(value) {
  return MOBILE_DIGITS.test(String(value ?? "").trim());
}

export function mobileError(value, label = "Mobile number") {
  const digits = String(value ?? "").trim();
  if (!digits) return `${label} is required.`;
  if (!/^[0-9]+$/.test(digits)) return `${label} must contain digits only.`;
  if (digits.length < MOBILE_LENGTH) return `${label} must be ${MOBILE_LENGTH} digits.`;
  return MOBILE_DIGITS.test(digits) ? null : `${label} must start with 6, 7, 8 or 9.`;
}